import { FC, PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';
import {
  getIsUserInternal,
  getProductGovernanceTimeoutMs,
  getQuoteIsProductGovernanceRequired,
  getQuoteRegulationProductGovernanceAssessment,
  getQuoteRegulationProductGovernanceDocumentation,
  getQuoteRegulationProductGovernanceDocumentationError,
  getQuoteRegulationProductGovernanceDocumentationTimeout,
  hasAnyErrorInProductGovernance,
  hasAnyProductGovernance,
  hasProductGovernanceAssessmentErrors,
  hasProductGovernanceErrors,
  isProductGovernanceAssessmentInError,
} from 'state/selectors';
import type { AppState } from 'state/state.model';
import type { QuoteWorkspaceType } from 'state/workspaces/model';

import { ProductGovernanceRegulatoryComponent } from './Regulatory.productGovernance';

export const ProductGovernanceRegulatory: FC<
  PropsWithChildren<{
    tabId: string;
    workspaceType: QuoteWorkspaceType;
    quoteId: string;
  }>
> = ({ tabId, quoteId, workspaceType }) => {
  const isInternalUser = useSelector((state: AppState) => getIsUserInternal(state));
  const isProductGovernanceRequired = useSelector((state: AppState) =>
    getQuoteIsProductGovernanceRequired(state, tabId),
  );
  const productGovernanceDocumentation = useSelector((state: AppState) =>
    getQuoteRegulationProductGovernanceDocumentation(state, tabId, quoteId),
  );
  const productGovernanceDocumentationError = useSelector((state: AppState) =>
    getQuoteRegulationProductGovernanceDocumentationError(state, tabId, quoteId),
  );
  const isPGTimeout =
    useSelector((state: AppState) => getQuoteRegulationProductGovernanceDocumentationTimeout(state, tabId, quoteId)) ??
    false;
  const productGovernanceAssessment = useSelector((state: AppState) =>
    getQuoteRegulationProductGovernanceAssessment(state, tabId, quoteId),
  );
  const hasPGErrors = useSelector((state: AppState) => hasProductGovernanceErrors(state, tabId, quoteId));
  const hasPGAssErrors = useSelector((state: AppState) => hasProductGovernanceAssessmentErrors(state, tabId, quoteId));
  const hasProductGovernance = useSelector((state: AppState) => hasAnyProductGovernance(state, tabId, quoteId));
  const isAssessmentInError = useSelector((state: AppState) =>
    isProductGovernanceAssessmentInError(state, tabId, quoteId),
  );
  const isInError = useSelector((state: AppState) => hasAnyErrorInProductGovernance(state, tabId, quoteId));

  const pgTimeoutMs = getProductGovernanceTimeoutMs();

  return (
    <ProductGovernanceRegulatoryComponent
      tabId={tabId}
      workspaceType={workspaceType}
      isProductGovernanceRequired={isProductGovernanceRequired}
      isInternalUser={isInternalUser}
      hasPGAssErrors={hasPGAssErrors}
      hasPGErrors={hasPGErrors}
      hasProductGovernance={hasProductGovernance}
      isPGTimeout={isPGTimeout}
      isProductGovernanceAssessmentInError={isAssessmentInError}
      isInError={isInError}
      isProductGovernanceLoading={!hasProductGovernance}
      productGovernanceAssessment={productGovernanceAssessment}
      productGovernanceDocumentation={productGovernanceDocumentation}
      productGovernanceDocumentationError={productGovernanceDocumentationError}
      pgTimeoutMs={pgTimeoutMs}
    />
  );
};
